export const DEV_CENTER_CLI_APP_ID = -1;
